import React, { useContext, useMemo } from 'react';
import CompareContext, { CompareContextOverride } from '../RecordObject/RecordCompareContext';
import Group from '../Group/RecordCompareGroup';
import DMLayoutGroup from '../DMLayoutGroup/DMLayoutGroup';
import { getChildLayout, getChildLayoutRecord } from '../../util/recordCompareRecordObject';
export default function LayoutGroup(_ref) {
  var property = _ref.property;
  var _useContext = useContext(CompareContext),
    records = _useContext.records,
    mergeRecord = _useContext.mergeRecord,
    layout = _useContext.layout;
  var childRecords = useMemo(function () {
    return records.map(function (record) {
      return getChildLayoutRecord(record, property);
    });
  }, [records, property]);
  var childMergeRecord = useMemo(function () {
    return getChildLayoutRecord(mergeRecord, property);
  }, [mergeRecord, property]);
  var childLayout = useMemo(function () {
    return getChildLayout(layout, property);
  }, [layout, property]);
  return /*#__PURE__*/React.createElement(Group, {
    property: property
  }, /*#__PURE__*/React.createElement(CompareContextOverride, {
    layout: childLayout,
    records: childRecords,
    mergeRecord: childMergeRecord
  }, /*#__PURE__*/React.createElement(DMLayoutGroup, null)));
}